import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-412" data-mp="1zj8wazjcd311">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-413" data-mp="24gio2lu7dqs1">
        <Header data-id="element-414" data-mp="24iv9j8z66j9u" />
        <Navigation data-id="element-415" data-mp="29gdaod6y3u7a" />
      </div>

      {/* Full-width ticker bar */}
      <MarketTicker data-id="element-416" data-mp="29i7v7qeb1kau" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-417" data-mp="2dhgs344n5yam">
        {/* Top Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-418" data-mp="3kvk5ok4kl15z">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-419" data-mp="3kuqun6ykvpi1" />
        </div>

        <main data-id="element-420" data-mp="30x1eq2xd22kp">
          <HeroSection data-id="element-421" data-mp="30vgouqlzr7t6" />
          <MarketStrip autoScroll data-id="element-422" data-mp="30up1g32jsgdz" />
          <BottomArticles data-id="element-423" data-mp="2vxydktki4gi0" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-424" data-mp="2vvvpif2wsxfx">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[90px]" text="Intralox Advertisement" data-id="element-425" data-mp="2qwsi4nzgif4s" />
        </div>
      </div>
    </div>;
}